import { Injectable, inject } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { WorkspaceFacadeService, SchemaFacadeService } from '@services/store-facade'
import { combineLatest, filter, shareReplay } from 'rxjs'
import { map } from 'rxjs/operators'
import { Logger } from '@services/logger/logger'

@Logger()
@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class WorkspaceTemplateConfigurationService {
    private readonly schemaFacadeService = inject(SchemaFacadeService)
    private readonly workspaceFacadeService = inject(WorkspaceFacadeService)

    private readonly workspaceTemplate$ = this.workspaceFacadeService.selectWorkspaceTemplate$.pipe(
        filter(Boolean),
    )
    private readonly templateData$ = combineLatest([
        this.schemaFacadeService.selectSelectedTableSchema$.pipe(filter(Boolean)),
        this.workspaceTemplate$,
    ]).pipe(
        untilDestroyed(this),
        map(([selectedSchema, workspaceTemplate]) => {
            const selectedTemplateSchema = workspaceTemplate.field_related_schemas.find(
                (schema) => schema.object_type_code === selectedSchema.object_type_code,
            )

            if (!selectedTemplateSchema) return

            return workspaceTemplate.fields_by_schemas[selectedTemplateSchema.guid]
        }),
        shareReplay(),
    )

    getTemplate$() {
        return this.workspaceTemplate$
    }

    getTemplateSystemSchemaFields$() {
        return this.templateData$
    }
}
